import React, { useState } from 'react';
import ModalLayout from '#components/Layouts/Modal/ModalLayout/ModalLayout';

export default function EmbeddedModal({
  trigger,
  content,
  className,
  nestedWidth = true,
}) {
  const [isOpen, setOpen] = useState(false);
  const open = () => setOpen(true);
  const close = () => setOpen(false);
  return (
    <>
      {trigger({ open, close })}
      {isOpen && (
        <ModalLayout className={className} nestedWidth={nestedWidth}>
          {content({ open, close })}
        </ModalLayout>
      )}
    </>
  );
}
